import {IReportConfigurationReportColumnDto} from 'store/slices/report-configuration-slice/report-configuration-dto';
import {TTableReportColumn} from 'store/slices/table-report-slice/table-report-slice-types';

export const mapReportColumns = (
    reportColumns: Record<string, IReportConfigurationReportColumnDto>,
): TTableReportColumn[] => Object.entries(reportColumns ?? {})
    .map(([columnKey, columnData]: [string, any]) => {
        const {
            columnOrdinal,
            hidden,
            reportTitle,
            ...rest
        } = columnData;

        return {
            key: columnOrdinal,
            permanentlyHidden: hidden,
            title: reportTitle,
            dataIndex: columnKey,
            ...rest,
        };
    }).filter(column => !column.permanentlyHidden);
